// extracted by mini-css-extract-plugin
export default {"kickstarterPage":"kickstarter_kickstarterPage__x7FIv"};